import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import VideoPlayer from '../components/VideoPlayer';
import { toast } from 'sonner';

const OfferA = ({ userId }) => {
  const navigate = useNavigate();
  const [processing, setProcessing] = useState(false);
  const price = 40;

  const handlePurchase = () => {
    setProcessing(true);
    toast.info('Stripe checkout would open here (requires API keys)');
    // In production, this would create a Stripe checkout session
    setTimeout(() => {
      setProcessing(false);
    }, 2000);
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      <main className="flex-1 container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-8">
            <div className="inline-block px-4 py-2 bg-purple-100 text-purple-800 rounded-full text-sm font-semibold mb-4">
              Standalone Offer
            </div>
            <h2 className="text-4xl md:text-5xl font-bold mb-4" style={{color: '#3D2817'}}>
              Ultimate Uganda Travel Guide
            </h2>
            <p className="text-xl text-gray-700">
              Complete digital report - Instant access!
            </p>
          </div>

          <div className="mb-8">
            <VideoPlayer videoUrl="" />
          </div>

          <div className="bg-white rounded-lg shadow-xl p-8">
            <h3 className="text-2xl font-bold mb-6" style={{color: '#8B3A9B'}}>
              What's Included:
            </h3>
            
            <div className="space-y-4 mb-8">
              <div className="flex items-start">
                <svg className="w-6 h-6 text-green-500 mr-3 flex-shrink-0 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                <p className="text-gray-700"><strong>200+ pages</strong> of comprehensive travel information</p>
              </div>
              <div className="flex items-start">
                <svg className="w-6 h-6 text-green-500 mr-3 flex-shrink-0 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                <p className="text-gray-700"><strong>Detailed itineraries</strong> for 7, 14, and 21-day trips</p>
              </div>
              <div className="flex items-start">
                <svg className="w-6 h-6 text-green-500 mr-3 flex-shrink-0 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                <p className="text-gray-700"><strong>Budget planning</strong> for every type of traveler</p>
              </div>
              <div className="flex items-start">
                <svg className="w-6 h-6 text-green-500 mr-3 flex-shrink-0 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                <p className="text-gray-700"><strong>Instant PDF download</strong> after purchase</p>
              </div>
            </div>

            <div className="bg-gradient-to-r from-purple-50 to-gold-50 rounded-lg p-8 text-center mb-8">
              <p className="text-gray-600 mb-2 text-lg">One-Time Payment</p>
              <div className="text-6xl font-bold mb-2" style={{color: '#8B3A9B'}}>
                ${price}
              </div>
              <p className="text-gray-600">Lifetime access • Instant download</p>
            </div>

            <button
              onClick={handlePurchase}
              disabled={processing}
              className="w-full py-4 rounded-lg font-bold text-white text-lg shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition disabled:opacity-50"
              style={{backgroundColor: '#8B3A9B'}}
              data-testid="purchase-offer-a"
            >
              {processing ? 'Processing...' : 'Yes I want the digital report'}
            </button>

            <div className="mt-6 text-center">
              <button
                onClick={() => navigate('/')}
                className="text-gray-600 hover:text-gray-800 font-medium"
              >
                ← Back to Home
              </button>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default OfferA;